document.addEventListener("DOMContentLoaded", (event) => {

    gsap.registerPlugin(ScrollTrigger);

    // ---------------------------------------------------
    // BANNER HERO: Aparece al cargar, sin scroll
    // ---------------------------------------------------
    const bannerHero = document.querySelector('.container-fluid-custom .tt-promo-box');

    if (bannerHero) {
        gsap.set(bannerHero, { opacity: 0 });
        gsap.to(bannerHero,
            {
                opacity: 1,
                duration: 1,
                ease: "power2.out",
                delay: 0.3
            }
        );
    }

    // ---------------------------------------------------
    // BANNER SIMPLE: Aparece al cargar, sin scroll
    // ---------------------------------------------------
    const bannerSimple = document.querySelector(
        '#shopify-section-template--20987574124591__index_section_simple_banners_HzMkxA .tt-promo-box'
    );

    if (bannerSimple) {
        gsap.set(bannerSimple, { autoAlpha: 0 });
        gsap.to(bannerSimple, {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.out",
            delay: 0.3
        });
    }

    // ---------------------------------------------------
    // MARQUEE TOP: El de arriba, aparece al cargar sin scroll
    // ---------------------------------------------------
    const primerMarquee = document.querySelector('.selene-marquee-track');
   
    if (primerMarquee) {
        gsap.fromTo(primerMarquee,
            { autoAlpha: 0 },
            {
                autoAlpha: 1,
                duration: 1,
                ease: "power2.out",
                delay: 0.6
            }
        );
    }

    // ---------------------------------------------------
    // RESTO DE SECCIONES: Con ScrollTrigger
    // ---------------------------------------------------
    const animacionesWokiee = [
        {
            contenedor: '.bento-principal',
            items: '.tt-promo-box'
        },
        {
            contenedor: '.tt-carousel-products-js',
            items: '.tt-product'
        },
        {
            contenedor: '.tt-block-title',
            items: '.tt-block-title__item, h2, .tt-title, span'
        },
        {
            contenedor: '.colecciones',
            items: '.tt-promo-box'
        },
        {
            contenedor: '.concept-steps',
            items: '.concept-step-item'
        },
        {
            contenedor: '[class*="preguntas_frecuentes"]',
            items: '[class*="faq-item-"]'
        },
        {
            contenedor: '.tt-filters-options',
            items: '.tt-title, .tt-sort, .tt-quantity, .tt-btn-toggle'
        },
        {
            contenedor: '.tt-product-listing',
            items: '.tt-col-item'
        },
        {
            contenedor: '.tt-services-listing',
            items: '.tt-services-block'
        },
        {
            contenedor: '.container-fluid',
            items: '.tt-layout-promo-box'
        },
    ];

    animacionesWokiee.forEach(animacion => {
        const secciones = document.querySelectorAll(animacion.contenedor);

        secciones.forEach((seccion) => {
            const elementos = seccion.querySelectorAll(animacion.items);
            if (elementos.length === 0) return;

            gsap.fromTo(elementos,
                { y: 30, autoAlpha: 0 },
                {
                    y: 0,
                    autoAlpha: 1,
                    duration: 1,
                    ease: "power2.out",
                    stagger: 0.1,
                    scrollTrigger: {
                        trigger: seccion,
                        start: "top 90%",
                        toggleActions: "play none none none",
                        once: true
                    }
                }
            );
        });
    });

    // ---------------------------------------------------
    // MARQUEES SECUNDARIOS: Los que están más abajo con ScrollTrigger
    // ---------------------------------------------------
    const todosLosMarquees = document.querySelectorAll('.selene-marquee-container');
   
    todosLosMarquees.forEach((seccion, index) => {
        if (index === 0) return;
       
        const track = seccion.querySelector('.selene-marquee-track');
        if (!track) return;

        gsap.fromTo(track,
            { y: 30, autoAlpha: 0 },
            {
                y: 0,
                autoAlpha: 1,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: seccion,
                    start: "top 90%",
                    toggleActions: "play none none none",
                    once: true
                }
            }
        );
    });
});